//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "source-notice",
  props:['sourceDto','defaultPar'],
  methods:{
    viewArticle(data){
      this.$router.push(`/article/${data.id}`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-common-module/source-notice.vue